module.exports = __webpack_public_path__ + "fonts/GillSansStd.ttf";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/fonts/GillSansStd.ttf
// module id = 90
// module chunks = 0